module.exports = __webpack_public_path__ + "static/media/lion.12d7e4e0.jpg";